/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

// Manual "Reconnect" clicks allowed until the next successful connection or login.
// Persisted in localStorage so a page refresh doesn't hand out a fresh allowance.
export const MAX_LIVE_SESSION_RECONNECTS = 10;

const STORAGE_KEY = 'live_session_reconnect_attempts';

export const getLiveSessionReconnectAttempts = () => {
  try {
    const value = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    return Number.isNaN(value) ? 0 : value;
  } catch {
    return 0;
  }
};

export const setLiveSessionReconnectAttempts = (attempts) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(attempts));
  } catch {
    // Storage unavailable -- the in-memory count in useLiveSession still applies.
  }
};

export const resetLiveSessionReconnectAttempts = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore -- nothing to reset.
  }
};
